import React, {
    createContext,
    useContext,
    useEffect,
    useState
} from 'react';
import {
    onAuthStateChanged,
    getAuth
} from 'firebase/auth';
import firebaseApp from 'config/firebase';
import axios from 'config/axios';
import Panel from 'components/Panel';

const auth = getAuth(firebaseApp);

export const AuthContext = createContext({ user: null, setUser: null });

export const useAuthContext = () => useContext(AuthContext);

export const AuthContextProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, user => {
            setLoading(true);
            if (user) {
                // setUser(user);
                axios.get('tutors/signin/')
                    .then(res => {
                        // console.log(res.data);
                        setUser(res.data);
                        setLoading(false);
                    })
                    .catch(error => {
                        console.log(error);
                        setLoading(false);
                    });
            }
            else {
                setUser(null);
                setLoading(false);
            }
        });

        return () => unsubscribe();
    }, []);

    return (
        <AuthContext.Provider value={{ user: user, setUser: setUser }}>
            {loading
                ?   <div className='app'>
                        <Panel />
                    </div>
                :   children
            }
        </AuthContext.Provider>
    );
}